// Priorités de notification — partagé par la liste des notifications reçues et par les annonces.
// Valeurs alignées sur la contrainte `chk_priority` / `admin_broadcasts_priority_check` (backend).

export const PRIORITY_CONFIG = {
  urgent: { label: 'Urgente', bg: 'bg-red-100', text: 'text-red-700' },
  high: { label: 'Haute', bg: 'bg-orange-100', text: 'text-orange-700' },
  normal: { label: 'Normale', bg: 'bg-blue-100', text: 'text-blue-700' },
  low: { label: 'Basse', bg: 'bg-gray-100', text: 'text-gray-700' },
};

export const PRIORITY_VALUES = ['low', 'normal', 'high', 'urgent'];
export const DEFAULT_PRIORITY = 'normal';

export const getPriorityConfig = (priority) => PRIORITY_CONFIG[priority] ?? PRIORITY_CONFIG.normal;
